import {NgModule} from "@angular/core";
import {AuthComponent} from "./auth/auth.component";
import {ClientSelectionComponent} from "./client-selection/client-selection.component";
import {ErrorComponent} from "./error/error.component";
import {ForgotComponent} from "./password/forgot.component";
import {RegisterComponent} from "./register/register.component";
import {StarterComponent} from "./starter/starter.component";
import {SharedModule} from "../../shared.module";
import {RouterModule} from "@angular/router";
import {DataTablesModule} from "angular-datatables";
import {ResetComponent} from "./password/reset.component";
import {ValidationService} from "../../services/validation.service";
import {MyCheckModule} from "../my-check/my-check.module";
import {ErrorloginComponent} from './errorlogin/errorlogin.component';
import {SelectModule} from "ng2-select-compat";
import {MultiselectModule} from "../multiselect/multiselect.module";


@NgModule({
	imports: [
		RouterModule,
		DataTablesModule,
		SharedModule,
		MyCheckModule,
		SelectModule,
		MultiselectModule
	],
    declarations: [
        AuthComponent,
        ClientSelectionComponent,
        ErrorComponent,
        ForgotComponent,
        ResetComponent,
        RegisterComponent,
        StarterComponent,
        ErrorloginComponent
    ],
    exports: [
    ],
    entryComponents: [
    ],
    providers: [
        ValidationService
    ]

})
export class FrameworkModule {} // end class FrameworkModule
